import React, { Component } from "react";
import uniqueId from "lodash/uniqueId";
import Aculistc3 from "c3/c3.js";
import { selection } from "d3-selection";
import * as d3format from "d3-format";
import { labels, legendlabels } from "./labels.js";
// import Share from './share.js';
const logo = require("./images/aculist-edge_logo.png");

class MarketTrends extends Component {
  constructor(props) {
    super(props);
 
    this.state = {
      btncharttypeactive: "",
      chartType: ""
    };
    this.handleImageClick = this.handleImageClick.bind(this);
  }
  componentWillMount() {   
    var btncharttypeactive = this.props.widgetselections.measure
      .toLowerCase()
      .indexOf("count")>0
      ? "bar"
      : "spline";
    var chartType = this.props.widgetselections.measure
      .toLowerCase()
      .indexOf("count")>0
      ? "bar"
      : "spline";
    this.setState({
      chartType: chartType,
      btncharttypeactive: btncharttypeactive
    });
  }

  componentWillReceiveProps(nextProps) {
    var btncharttypeactive = nextProps.widgetselections.measure
      .toLowerCase()
      .indexOf("count")>0
      ? "bar"
      : "spline";
    var chartType = nextProps.widgetselections.measure
      .toLowerCase()
      .indexOf("count")>0
      ? "bar"
      : "spline";
    this.setState({
      chartType: chartType,
      btncharttypeactive: btncharttypeactive
    });
  }

  handleImageClick(e) {
    e.preventDefault();
  
  }

  render() {
 
    var countyarray = [...this.props.data.map(item => item.County )];   
    var countycount = countyarray.filter((v, i, a) => a.indexOf(v) === i); 
    //var countycount = Array.from(unique);
    let newpropdata  =[];
    if(countycount.length>1)
    { 
      console.log('multicounty',countycount.length);
      var maxinventory = Math.max(...this.props.data.map(item => item.InventoryCount));
      var inventoryfilter=  this.props.data.filter(rec=>rec.InventoryCount==maxinventory);
      newpropdata=this.props.data.filter(countyrec=>countyrec.County==inventoryfilter[0].County);
    }
    else
    {
      console.log('singlecounty',countycount.length);
      newpropdata=this.props.data;
    }
    
    let logoStyles = {
      height: '16px',
      width: '72px',
      background: `url(${logo})`
    }   

    let M2Title=this.props.widgetselections.measure.split(",")[1]===undefined ?'':" & "+  labels[this.props.widgetselections.measure.split(",")[1]];
    let baseTitle=decodeURIComponent(this.props.widgetselections.geo[0].split(":")[1])+' '+labels[this.props.widgetselections.measure.split(",")[0]]+ M2Title;
 
    let areaTitle =typeof this.props.data==='undefined' ?"":this.props.data.length==0?'':
     ( this.props.widgetselections.geo[0].split(":")[0] == "Area" && this.props.data[0].AreaId!=null)
        ? "(MLS AREA" + this.props.data[0].AreaId + ")"
        : "";
    return (
      <div className="titleChartHolder">
        {/* <div className="chartShare"><Share divid={this.props.widgetselections.divid}/></div> */}
        <div className={`chartTitle ${this.props.widgetselections.title === 'false' ? "hidden" : ""}`}>
       
         {baseTitle+ areaTitle}        
        </div>

        <div key={uniqueId("marketTrendsChart-")} className="section_container">
          <Chart
            {...this.props}
            id={this.props.id}
            data1={newpropdata}
            widgetselections={this.props.widgetselections}
            chartType={this.state.chartType}
          />
          <div className={`chartOptionsRow ${this.props.optionclasses}`}>
            <span className="externalOptions">{this.props.children}</span>
            <span className="mx-auto d-block attribution-holder text-center clearfix pos-relative">
              <span className="d-inline-block attribution-label">
                Powered by:
              </span>
              <a
                href="http://aculist.com/"
                target="_blank"
                className="attribution-img" >
                <span className="d-inline-block logoclass" style={logoStyles}></span>
                {/* <img src={logo} onClick={this.handleImageClick}/> */}
              </a>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

class Chart extends React.Component {
  componentDidMount() {

    if(this.props.widgetselections.measure.split(",").length==1)
      {this._updateSingleAxesChart(
        this.props.data1,
        this.props.widgetselections,
        this.props.assets
      );}
    else
      
    if (this.props.widgetselections.measure.indexOf("Volume")>0) {
      this._updateChartTotal(
        this.props.data1,
        this.props.widgetselections,
        this.props.assets
      );
    } else
      this._updateChart(
        this.props.data1,
        this.props.widgetselections,
        this.props.assets
      );
  }

  componentDidUpdate() {
    if(this.props.widgetselections.measure.split(",").length==1)
      {this._updateSingleAxesChart(
        this.props.data1,
        this.props.widgetselections,
        this.props.assets
      );}
    else
    if (this.props.widgetselections.measure.indexOf("Volume")>0) {
      this._updateChartTotal(
        this.props.data1,
        this.props.widgetselections,
        this.props.assets
      );
    } else
      this._updateChart(
        this.props.data1,
        this.props.widgetselections,
        this.props.assets
      );
  }

  _updateChart(data1, ws, assets) {
    var measurearray = ws.measure.split(",");
    var masterarray = [];
    var periodarray = [];

    
    var SFarrayM1 = ["SFHM1"];
    var CIarrayM1 = ["C/TM1"];
    var SFarrayM2 = ["SFHM2"];
    var CIarrayM2 = ["C/TM2"];

    var periodarrayasc = [];
    var periodarrayformatted = ["Period"];

    data1.forEach(function(record) {
      if (periodarrayasc.indexOf(record.Period) === -1) {
        periodarrayasc.push(record.Period);
      }
    });
    periodarrayasc.reverse().forEach(function(x) {
      periodarray.push(x);
    });



    periodarray.forEach(function(periodrecord) {
    let filtereddata1=data1.filter(rec=>rec.Period===periodrecord)
  

    filtereddata1.forEach(function(record) { 
      if(filtereddata1.length==2){     
      record.Class.toLowerCase() == "residential - single family" 
          ? SFarrayM1.push(record[measurearray[0].toString()]) && SFarrayM2.push(record[measurearray[1].toString()])
          : record.Class.toLowerCase() == "residential - common interest" 
            ? CIarrayM1.push(record[measurearray[0].toString()]) && CIarrayM2.push(record[measurearray[1].toString()])
            : "";
      }else
      {
        record.Class.toLowerCase() == "residential - single family" 
        ? SFarrayM1.push(record[measurearray[0].toString()]) && SFarrayM2.push(record[measurearray[1].toString()]) &&
        CIarrayM1.push(null) && CIarrayM2.push(null)
        : record.Class.toLowerCase() == "residential - common interest" 
          ? CIarrayM1.push(record[measurearray[0].toString()]) && CIarrayM2.push(record[measurearray[1].toString()]) &&
          SFarrayM1.push(null) && SFarrayM2.push(null)
          : "";
        
      }
   
      });
  
    
    });
  

    if (ws.periodtype.toLowerCase() == "month") {
      var monthnames = {
        "01": "Jan",
        "02": "Feb",
        "03": "Mar",
        "04": "Apr",
        "05": "May",
        "06": "Jun",
        "07": "Jul",
        "08": "Aug",
        "09": "Sep",
        "10": "Oct",
        "11": "Nov",
        "12": "Dec"
      };
      periodarray.forEach(function(periodraw) {
        periodarrayformatted.push(
          monthnames[periodraw.substring(5)] + " " + periodraw.substring(2, 4)
        );
      });
    } else if (ws.periodtype.toLowerCase() == "quarter") {
      periodarray.forEach(function(periodraw) {
        periodarrayformatted.push(
          periodraw.substring(4, 6) + " " + periodraw.substring(2, 4)
        );
      });
    } else {
      periodarray.forEach(function(periodrecord) {
        periodarrayformatted.push(periodrecord);
      });
    }

    masterarray.push(periodarrayformatted);

    if(this.props.widgetselections.classtype.split(',').length==2 )
      {
        SFarrayM1.length > 1 ? masterarray.push(SFarrayM1) : "";
        CIarrayM1.length > 1 ? masterarray.push(CIarrayM1) : "";
        SFarrayM2.length > 1 ? masterarray.push(SFarrayM2) : "";
        CIarrayM2.length > 1 ? masterarray.push(CIarrayM2) : "";
          }
          else if(this.props.widgetselections.classtype.indexOf('Single Family')>0)
      {       
        SFarrayM1.length > 1 ? masterarray.push(SFarrayM1) : "";
    SFarrayM2.length > 1 ? masterarray.push(SFarrayM2) : "";}
    else if(this.props.widgetselections.classtype.indexOf('Common Interest')>0)
      {
        CIarrayM1.length > 1 ? masterarray.push(CIarrayM1) : "";
        CIarrayM2.length > 1 ? masterarray.push(CIarrayM2) : "";
      }
   

    let defaultcolors = [
      "RGB(86,108,17)",
      "RGB(208,111,32)",
      "RGB(0,0,0)",
      "RGB(255,217,102)"
    ];
    //let defaultcolors=[ 'RGB(126,159,26)', 'RGB(230,145,56)','RGB(0,0,0)', 'RGB(255,217,102)']
    let preferredcolors = [];
    assets
      .filter(
        prefrow =>
          prefrow.AttributeKey.toLowerCase().indexOf("vprimcolor")>0 ||
          prefrow.AttributeKey.toLowerCase().indexOf("vseccolor")>0
      )
      .forEach(function(pref) {
        preferredcolors.push(pref.AttributeValue);
      });
    defaultcolors.forEach(function(defcol) {
      if (!preferredcolors.indexOf(defcol)>0) {
        preferredcolors.push(defcol);
      }
    });

    const chart = Aculistc3.generate({
      padding: { top: 50, left: 50, bottom: 20 },
      bindto: "#" + this.props.id,
      position: "inset",
      padding: {
        top: 40
      },

      data: {
        types: {
          SFHM2: "spline",
          "C/TM2": "spline",
          SFHM1: "bar",
          "C/TM1": "bar"
        },
        x: "Period",
        columns: masterarray,
        axes: {
          SFHM2: "y2",
          "C/TM2": "y2",
          SFHM1: "y",
          "C/TM1": "y"
        },
        labels: "true",
        names: {
          SFHM1: "SFH " + legendlabels[measurearray[0]],
          "C/TM1": "C/T " + legendlabels[measurearray[0]],
          SFHM2: "SFH " + legendlabels[measurearray[1]],
          "C/TM2": "C/T " + legendlabels[measurearray[1]]
        }
      },
      point: {
        r: 0
      },
      color: {
        pattern: [
          "RGB(86,108,17)",
          "RGB(208,111,32)",
          "RGB(255,217,102)",
          "RGB(0,0,0)"
        ]
      },
      axis: {
        y2: {
          // padding:10,
          tick: {
            outer: false,
            format:
            measurearray[1].toLowerCase().indexOf("over") >0
              ? d3format.format(".0%")
              :measurearray[1].toLowerCase().indexOf("price")>0 ?d3format.format("$,")
              :""
          },
          show: true,
          label: {
            text: labels[measurearray[1]],
            position: "outer-middle"
          }
        },
        y: {
          //  padding:50,
          tick: {
            outer: false,          
            format:
            measurearray[0].toLowerCase().indexOf("over") >0
            ? d3format.format(".0%")
            :measurearray[0].toLowerCase().indexOf("price")>0 ?d3format.format("$,")
                :""
          },
          label: {
            text: labels[measurearray[0]],
            position: "outer-middle"
          }
        },
        x: {
          tick: {
            multiline: false,
            outer: false
          },

          type: "category",
          label: {
            text: ws.periodtype,
            position: "outer-center",
            font: "12px"
          }
        }
      },
      grid: {
        y: {
          show: true
        }
      },

      zoom: {
        enabled: false
      },
      bar: {
        space: 0.1,
        width: {
          //  ratio: 0.5,// this makes bar width 50% of length between ticks
        }
        //space:.25
        // or
        //width: 100 // this makes bar width 100px
      }
    });
  }

  _updateChartTotal(data1, ws, assets) {
    var measurearray = ws.measure.split(",");
    var masterarray = [];
    var periodarray = [];

    var SFarrayM1 = [];
    var CIarrayM1 = [];
    var SFarrayM2 = [];
    var CIarrayM2 = [];

    var periodarrayasc = [];
    var periodarrayformatted = ["Period"];

    data1.forEach(function(record) {
      if (periodarrayasc.indexOf(record.Period) === -1) {
        periodarrayasc.push(record.Period);
      }
    });
    periodarrayasc.reverse().forEach(function(x) {
      periodarray.push(x);
    });

    periodarray.forEach(function(periodrecord) {
      let filtereddata1=data1.filter(rec=>rec.Period===periodrecord)
      
  
      filtereddata1.forEach(function(record) { 
        if(filtereddata1.length==2){     
        record.Class.toLowerCase() == "residential - single family" 
            ? SFarrayM1.push(record[measurearray[0].toString()]) && SFarrayM2.push(record[measurearray[1].toString()])
            : record.Class.toLowerCase() == "residential - common interest" 
              ? CIarrayM1.push(record[measurearray[0].toString()]) && CIarrayM2.push(record[measurearray[1].toString()])
              : "";
        }else
        {
          record.Class.toLowerCase() == "residential - single family" 
          ? SFarrayM1.push(record[measurearray[0].toString()]) && SFarrayM2.push(record[measurearray[1].toString()]) &&
          CIarrayM1.push(null) && CIarrayM2.push(null)
          : record.Class.toLowerCase() == "residential - common interest" 
            ? CIarrayM1.push(record[measurearray[0].toString()]) && CIarrayM2.push(record[measurearray[1].toString()]) &&
            SFarrayM1.push(null) && SFarrayM2.push(null)
            : "";
          
        }
     
        });
    
      
      });
   
    
    var TarrayM1 = SFarrayM1.map(function (num, idx) {   
      return Number(num) + Number(CIarrayM1[idx]);
    }); 
    var TarrayM2= SFarrayM2.map(function (num, idx) {    
      return Number(num) + Number(CIarrayM2[idx]);
    }); 
    TarrayM1.unshift('TM1');
    TarrayM2.unshift('TM2');


    if (ws.periodtype.toLowerCase() == "month") {
      var monthnames = {
        "01": "Jan",
        "02": "Feb",
        "03": "Mar",
        "04": "Apr",
        "05": "May",
        "06": "Jun",
        "07": "Jul",
        "08": "Aug",
        "09": "Sep",
        "10": "Oct",
        "11": "Nov",
        "12": "Dec"
      };
      periodarray.forEach(function(periodraw) {
        periodarrayformatted.push(
          monthnames[periodraw.substring(5)] + " " + periodraw.substring(2, 4)
        );
      });
    } else if (ws.periodtype.toLowerCase() == "quarter") {
      periodarray.forEach(function(periodraw) {
        periodarrayformatted.push(
          periodraw.substring(4, 6) + " " + periodraw.substring(2, 4)
        );
      });
    } else {
      periodarray.forEach(function(periodrecord) {
        periodarrayformatted.push(periodrecord);
      });
    }

    masterarray.push(periodarrayformatted);
    TarrayM1.length > 1 ? masterarray.push(TarrayM1) : "";
    TarrayM2.length > 1 ? masterarray.push(TarrayM2) : "";


    let defaultcolors = [
      "RGB(86,108,17)",
      "RGB(208,111,32)",
      "RGB(0,0,0)",
      "RGB(255,217,102)"
    ];
    //let defaultcolors=[ 'RGB(126,159,26)', 'RGB(230,145,56)','RGB(0,0,0)', 'RGB(255,217,102)']
    let preferredcolors = [];
    assets
      .filter(
        prefrow =>
          prefrow.AttributeKey.toLowerCase().indexOf("vprimcolor")>0 ||
          prefrow.AttributeKey.toLowerCase().indexOf("vseccolor")>0
      )
      .forEach(function(pref) {
        preferredcolors.push(pref.AttributeValue);
      });
    defaultcolors.forEach(function(defcol) {
      if (!preferredcolors.indexOf(defcol)>0) {
        preferredcolors.push(defcol);
      }
    });
    const chart = Aculistc3.generate({
      padding: { top: 50, left: 50, bottom: 20 },
      bindto: "#" + this.props.id,
      position: "inset",
      padding: {
        top: 40
      },

      data: {
        types: {
          TM1: "bar",        
          TM2: "spline",
         
        },
        x: "Period",
        columns: masterarray,
        axes: {
          TM1: "y",       
          TM2: "y2",
      
        },
        labels: "true",
        names: {
          TM1: "Total " + legendlabels[measurearray[0]],       
          TM2: "Total " + legendlabels[measurearray[1]],
       
        }
      },
      point: {
        r: 0
      },
      color: {
        pattern: 
        // [
        //   "RGB(86,108,17)",
        //   "RGB(208,111,32)",
        //   "RGB(255,217,102)",
        //   "RGB(0,0,0)"
        // ]
        preferredcolors
      },
      axis: {
        y2: {
          // padding:10,
          tick: {
            outer: false,
            format:
            measurearray[1].toLowerCase().indexOf("over")>0 ?d3format.format(".0%")   :
            measurearray[1].toLowerCase().indexOf("price")>0 || measurearray[1] == "SaleVolume"
            ? d3format.format("$,")               
            :""
          },
          show: true,
          label: {
            text: labels[measurearray[1]],
            position: "outer-middle"
          }
        },
        y: {
          //  padding:50,
          tick: {
            outer: false,
            //  format: function (d) {if (d != "2" && d != "6" && d != "10" && d != "14" && d != "18" ) return d + "%"}
            format:
            measurearray[1].toLowerCase().indexOf("over")>0 ?d3format.format(".0%")   :
            measurearray[1].toLowerCase().indexOf("price")>0 || measurearray[1] == "SaleVolume"
            ? d3format.format("$,")     
              :""
          },
          label: {
            text: labels[measurearray[0]],
            position: "outer-middle"
          }
        },
        x: {
          tick: {
            multiline: false,
            outer: false
          },

          type: "category",
          label: {
            text: ws.periodtype,
            position: "outer-center",
            font: "12px"
          }
        }
      },
      grid: {
        y: {
          show: true
        }
      },

      zoom: {
        enabled: false
      },
      bar: {
        space: 0.1,
        width: {
          //  ratio: 0.5,// this makes bar width 50% of length between ticks
        }
        //space:.25
        // or
        //width: 100 // this makes bar width 100px
      }
    });
  }

  _updateSingleAxesChart(data1, ws, assets) {
    var measurearray = ws.measure.split(",");
    var masterarray = [];
    var periodarray = [];

    var SFarrayM1 = ["SFHM1"];
    var CIarrayM1 = ["C/TM1"];

    var periodarrayasc = [];
    var periodarrayformatted = ["Period"];

    data1.forEach(function(record) {
      if (periodarrayasc.indexOf(record.Period) === -1) {
        periodarrayasc.push(record.Period);
      }
    });
    periodarrayasc.reverse().forEach(function(x) {
      periodarray.push(x);
    });


    periodarray.forEach(function(periodrecord) {
    let filtereddata1=data1.filter(rec=>rec.Period===periodrecord)
  

    filtereddata1.forEach(function(record) { 
      if(filtereddata1.length==2){     
      record.Class.toLowerCase() == "residential - single family" 
          ? SFarrayM1.push(record[measurearray[0].toString()]) 
          : record.Class.toLowerCase() == "residential - common interest" 
            ? CIarrayM1.push(record[measurearray[0].toString()]) 
            : "";
      }else
      {
        record.Class.toLowerCase() == "residential - single family" 
        ? SFarrayM1.push(record[measurearray[0].toString()])  &&
        CIarrayM1.push(null) 
        : record.Class.toLowerCase() == "residential - common interest" 
          ? CIarrayM1.push(record[measurearray[0].toString()])  &&
          SFarrayM1.push(null) 
          : "";
        
      }
   
      });
  
    
    });
  

    if (ws.periodtype.toLowerCase() == "month") {
      var monthnames = {
        "01": "Jan",
        "02": "Feb",
        "03": "Mar",
        "04": "Apr",
        "05": "May",
        "06": "Jun",
        "07": "Jul",
        "08": "Aug",
        "09": "Sep",
        "10": "Oct",
        "11": "Nov",
        "12": "Dec"
      };
      periodarray.forEach(function(periodraw) {
        periodarrayformatted.push(
          monthnames[periodraw.substring(5)] + " " + periodraw.substring(2, 4)
        );
      });
    } else if (ws.periodtype.toLowerCase() == "quarter") {
      periodarray.forEach(function(periodraw) {
        periodarrayformatted.push(
          periodraw.substring(4, 6) + " " + periodraw.substring(2, 4)
        );
      });
    } else {
      periodarray.forEach(function(periodrecord) {
        periodarrayformatted.push(periodrecord);
      });
    }

    masterarray.push(periodarrayformatted);


    if(this.props.widgetselections.classtype.split(',').length==2 )
      {
        SFarrayM1.length > 1 ? masterarray.push(SFarrayM1) : "";
        CIarrayM1.length > 1 ? masterarray.push(CIarrayM1) : "";
          }
          else if(this.props.widgetselections.classtype.indexOf('Single Family')>0)
      {       
        SFarrayM1.length > 1 ? masterarray.push(SFarrayM1) : "";}
    else if(this.props.widgetselections.classtype.indexOf('Common Interest')>0)
      {
        CIarrayM1.length > 1 ? masterarray.push(CIarrayM1) : "";
      }







    let defaultcolors = [
      "RGB(86,108,17)",
      "RGB(208,111,32)",
      "RGB(0,0,0)",
      "RGB(255,217,102)"
    ];
    //let defaultcolors=[ 'RGB(126,159,26)', 'RGB(230,145,56)','RGB(0,0,0)', 'RGB(255,217,102)']
    let preferredcolors = [];
    assets
      .filter(
        prefrow =>
          prefrow.AttributeKey.toLowerCase().indexOf("vprimcolor")>0 ||
          prefrow.AttributeKey.toLowerCase().indexOf("vseccolor")>0
      )
      .forEach(function(pref) {
        preferredcolors.push(pref.AttributeValue);
      });
    defaultcolors.forEach(function(defcol) {
      if (!preferredcolors.indexOf(defcol)>0) {
        preferredcolors.push(defcol);
      }
    });

    const chart = Aculistc3.generate({
      padding: { top: 50, left: 50, bottom: 20 },
      bindto: "#" + this.props.id,
      position: "inset",
      padding: {
        top: 40
      },

      data: {
        types: {
          SFHM1: "bar",
          "C/TM1": "bar"
        },
        x: "Period",
        columns: masterarray,
        axes: {
          SFHM1: "y",
          "C/TM1": "y"
        },
        labels: "true",
        names: {
          SFHM1: "SFH " + legendlabels[measurearray[0]],
          "C/TM1": "C/T " + legendlabels[measurearray[0]]

        }
      },
      point: {
        r: 0
      },
      color: {
        pattern: [
          "RGB(86,108,17)",
          "RGB(208,111,32)",
          "RGB(255,217,102)",
          "RGB(0,0,0)"
        ]
      },
      axis: {
        y: {
          //  padding:50,
          tick: {
            outer: false,          
            format:
            measurearray[0].toLowerCase().indexOf("over")>0 ?d3format.format(".0%")    :
            measurearray[0].toLowerCase().indexOf("price")>0 || measurearray[0] == "SaleVolume"
            ? d3format.format("$,")            
                :""
          },
          label: {
            text: labels[measurearray[0]],
            position: "outer-middle"
          }
        },
        x: {
          tick: {
            multiline: false,
            outer: false
          },

          type: "category",
          label: {
            text: ws.periodtype,
            position: "outer-center",
            font: "12px"
          }
        }
      },
      grid: {
        y: {
          show: true
        }
      },

      zoom: {
        enabled: false
      },
      bar: {
        space: 0.1,
        width: {
          //  ratio: 0.5,// this makes bar width 50% of length between ticks
        }
        //space:.25
        // or
        //width: 100 // this makes bar width 100px
      }
    });
  }

  render() {
    return (
      <div id={this.props.id} className={this.props.chartclasses}>
        Error
      </div>
    );
  }
}

export default MarketTrends;



// WEBPACK FOOTER //
// ./src/MarketTrends.js